import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-operation-log",
  "use": "icon-operation-log-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-operation-log\">\r\n<style type=\"text/css\">\r\n\t\r\n</style>\r\n<path class=\"st0\" d=\"M14,8c0-3.3-2.7-6-6-6S2,4.7,2,8s2.7,6,6,6S14,11.3,14,8z M16,8c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8\r\n\tS16,3.6,16,8z M9,7.6l2.7,2.7l.4,1.4L7,8.4V4h2V7.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol